import axios from "./axios";

export async function fetchWebPage(slug) {
  const response = await axios.get(`/webpage/pages/${slug}`);
  return response;
}

export async function fetchWebPages(params = {}) {
  const response = await axios.get(`/webpage/pages`, { params });
  return response;
}

export async function fetchWebPost(slug) {
  const response = await axios.get(`/webpage/posts/${slug}`);
  return response;
}

export async function fetchWebPosts(params = {}) {
  const response = await axios.get(`/webpage/posts`, { params });
  return response;
}

export async function fetchWebSitemap() {
  const response = await axios.get(`/webpage/sitemap`);
  return response;
}
